// Shared status-date extraction for the EFT / Check / Debit payment reports.

function safe(fn) {
    try {
        return fn();
    } catch {
        return "";
    }
}

/**
 * @param {object} claim_data
 * @param {string} dos date_of_service
 * @param {object} [options]
 * @param {boolean} [options.splitTime] Quirk preserved from the EFT on-screen
 *   table only: drops the time portion of the paid/requested timestamps.
 */
export function getStatusDates(claim_data, dos, { splitTime = false } = {}) {
    const normalize = (value) => (splitTime ? value.split(" ")[0] : value);
    return {
        paid_date: safe(() => normalize(claim_data.paid_date)),
        requested_date: safe(() => normalize(claim_data.requested_date)),
        date_of_service: safe(() => dos),
    };
}

/** paid_date, else requested_date, else date_of_service. */
export function pickStatusDate({ paid_date, requested_date, date_of_service }) {
    if (paid_date != "" && paid_date != null) return paid_date;
    if (requested_date != "" && requested_date != null) return requested_date;
    return date_of_service;
}


